// Define the TaskType values to match the server-side TaskType Enum, see basic_types.py on server side
export enum TaskType {
    CommitteReview = "CommitteReview",
    GenerateEssayIdeas = "GenerateEssayIdeas",
    EssayPromptAnalysis = "EssayPromptAnalysis",
    RefineEssayIdea = "RefineEssayIdea",
    BuildCollegeList = "BuildCollegeList",
    GetCollegeDataChance = "GetCollegeDataChance",
    MyChance = "MyChance",
    DraftEssay = "DraftEssay",
    RefineEssay = "RefineEssay",
    AnalyzeInterview = "AnalyzeInterview",
    CompareCollege = "CompareCollege",
    RecommendEaEdRegular = "RecommendEaEdRegular",
}


